import React from "react";

/**
 * CheckboxGroup component
 *
 * Props:
 *  - options: Array<string|number>
 *  - selected: Array<string|number>
 *  - onToggle: (option: string|number) => void
 *  - renderLabel?: (option: string|number) => string
 */
export function CheckboxGroup({
  options,
  selected,
  onToggle,
  renderLabel,
}) {
  return (
    <div className="flex flex-wrap gap-2">
      {options.map((option) => {
        const isActive = selected.includes(option);
        const labelText = renderLabel
          ? renderLabel(option)
          : String(option);
        return (
          <label
            key={option}
            className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium border cursor-pointer transition-colors ${
              isActive 
                ? "bg-blue-100 text-blue-800 border-blue-300" 
                : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
            }`}
          >
            <input
              type="checkbox"
              className="hidden"
              checked={isActive}
              onChange={() => onToggle(option)}
            />
            {labelText}
          </label>
        );
      })}
    </div>
  );
}